import { PushpinOutlined, PushpinFilled } from '@ant-design/icons'
import { Button, Typography } from 'modules/core/components'

const ButtonFix = ({ isFixed, setFixed }) => {
  return (
    <Button.Icon
      style={isFixed ? { cursor: 'default' } : {}}
      icon={<Typography.Icon level={2} icon={isFixed ? PushpinFilled : PushpinOutlined} />}
      onClick={(e) => {
        e.stopPropagation()
        !isFixed && setFixed()
      }}
    />
  )
}

export default ButtonFix
